import { ENV } from '@/infrastructure/env-config';
import { Platform } from '@/infrastructure/utils/app';

/**
 * 产品相关
 */
export default {
  demoProduct: ENV.isProd ? [
    { productId: 'a278f01047', platformId: Platform.Android },
    { productId: 'a2031e998b', platformId: Platform.IOS },
  ] : [
    { productId: '0218f9b5f3', platformId: Platform.Android }, // 测试环境
    { productId: '3e8351b231', platformId: Platform.IOS },
  ],
};
